module.exports = __webpack_public_path__ + "img/Form.5167bd51.svg";